import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import ApiCallServices from "../../../../../services/ApiCallServices";
import { END_POINTS } from "../../../../../services/endpoint/endPoint";
import GeoList from "./child/GeoList";

const Geo = () => {
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [sortingColumn, setSortingColumn] = useState(null);
  const [sortingOrder, setSortingOrder] = useState("asc");

  const handleSort = (column) => {
    if (sortingColumn === column) {
      setSortingOrder(sortingOrder === "asc" ? "desc" : "asc");
    } else {
      setSortingColumn(column);
      setSortingOrder("asc");
    }
  };

  const updateStatus = async (ccode, status) => {
    try {
      const res = await ApiCallServices.create(END_POINTS.updateGeoStatus, {
        ccode,
        status,
      });

      if (res.status === 200) {
        toast.success(res.data.message || "Status updated", {
          position: "top-right",
        });
        getGeosTableData();
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to update status", {
        position: "top-right",
      });
    }
  };

  const updateSegmentStatus = async (ccode, segment_status) => {
    try {
      const res = await ApiCallServices.create(
        END_POINTS.updateGeoSegmentStatus,
        {
          ccode,
          segment_status,
        }
      );

      if (res.status === 200) {
        toast.success(res.data.message || "Segment status updated", {
          position: "top-right",
        });
        getGeosTableData();
      }
    } catch (error) {
      toast.error(
        error.response?.data?.error || "Failed to update segment status",
        {
          position: "top-right",
        }
      );
    }
  };

  const getGeosTableData = async () => {
    setLoader(true);
    const data = {
      name: search,
      sortingcolumn: sortingColumn,
      sortingorder: sortingOrder,
    };
    try {
      const res = await ApiCallServices.create(END_POINTS.geosTableData, data);
      if (res.status === 200) {
        setTableData(res.data.data);
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Error fetching data", {
        position: "top-right",
      });
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getGeosTableData();
  }, [search, sortingColumn, sortingOrder]);

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
      <div className='filter-wraper justify-content-between'>
          <div className='d-flex align-items-center fields'>
              <h3>Manage GEO</h3>
          </div>
      </div>

        <div className="filter-wraper d-flex justify-content-between">
          <div className="d-flex align-items-center fields">
            <div className="form-group search-icon">
              <input
                type="text"
                className="form-control"
                onChange={(e) =>
                  setSearch(e.target.value.length > 1 ? e.target.value : "")
                }
                placeholder="Search geos"
              />
            </div>
          </div>
        </div>

        <GeoList
          tableData={tableData}
          updateStatus={updateStatus}
          updateSegmentStatus={updateSegmentStatus}
          loader={loader}
          onSort={handleSort}
          sortingColumn={sortingColumn}
          sortingOrder={sortingOrder}
        />
      </div>
    </>
  );
};

export default Geo;
